import * as React from 'react';
import Card from '@mui/material/Card';
import Icn from '../Icn';
import IconBtn from '../IconBtn';
import { colors } from '../../maps/colors';
import FieldShelf from './FieldShelf';

export default function InstallerFieldCard(props) {
    const { shelves, width, height } = props;

    return (
        <Card onClick={props.onClick} sx={{ width: '100%', marginBottom: '5px', background: props.selected ? colors.LIGHT_GREEN + "50" : 'white' }}>
            <div style={{ padding: 5 }}>
                <Icn style={{ position: 'relative', top: 4 }}>field</Icn> <span style={{ fontSize: 18, fontWeight: 500 }}>{props.name}</span>
                <div style={{ fontWeight: 'bold', fontSize: 12, paddingLeft: 28 }}>[{props.piNumber}] {width}x{height}</div>
            </div>
            <div style={{ padding: 3 }}>
                {
                    shelves.map(shelf => <FieldShelf width={100} card_view={true} key={shelf._id} {...shelf} />)
                }
            </div>
            <div style={{ padding: 5 }}>
                <IconBtn customtheme="small-gray" size="small" onClick={props.onEdit}>edit</IconBtn>
                <IconBtn customtheme="small-gray" size="small" style={{ marginLeft: 5 }} onClick={props.onDelete}>delete</IconBtn>
            </div>
        </Card>
    );
}